<h3 class="text-md py-4 font-bold">Aux. Engine Consumptions (Breakdown)</h3>

<form
  #form="ngForm"
  novalidate
>
  <div class="mt-2 flex flex-row gap-1">
    <div class="flex flex-1 flex-col content-center items-end gap-1">
      <nsp-input-label
        class="h-10.5"
        label="Basic Load (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Ballast Operations (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Cargo Heating (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Tank Cleaning (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Cargo Discharging (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Inert Gas Systems (MT)"
      />
      <nsp-input-label
        class="h-10.5"
        label="Bunker Heating (MT)"
      />
    </div>

    @for (
      item of object.values(consumptionsStore.auxEngineConsumptions().entries);
      let i = $index;
      track i
    ) {
      @let rowIndex = $index;
      <div class="flex flex-1 flex-col gap-1">
        <nsp-number-input
          [id]="`entries-basicLoad-${rowIndex}`"
          [name]="`entries-basicLoad-${rowIndex}`"
          [min]="0"
          [value]="consumptionsStore.vm().calculateAEBasicLoad(rowIndex)"
          [ngModel]="consumptionsStore.vm().calculateAEBasicLoad(rowIndex)"
          [readonly]="true"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
          nspNonNegative
        />
        <nsp-number-input
          [id]="`entries-ballastOperations-${rowIndex}`"
          [name]="`entries-ballastOperations-${rowIndex}`"
          [min]="0"
          [value]="item.ballastOperations.value"
          [ngModel]="item.ballastOperations.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
        <nsp-number-input
          [id]="`entries-cargoHeating-${rowIndex}`"
          [name]="`entries-cargoHeating-${rowIndex}`"
          [min]="0"
          [value]="item.cargoHeating.value"
          [ngModel]="item.cargoHeating.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
        <nsp-number-input
          [id]="`entries-tankCleaning-${rowIndex}`"
          [name]="`entries-tankCleaning-${rowIndex}`"
          [min]="0"
          [value]="item.tankCleaning.value"
          [ngModel]="item.tankCleaning.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
        <nsp-number-input
          [id]="`entries-cargoDischarging-${rowIndex}`"
          [name]="`entries-cargoDischarging-${rowIndex}`"
          [min]="0"
          [value]="item.cargoDischarging.value"
          [ngModel]="item.cargoDischarging.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
        <nsp-number-input
          [id]="`entries-inertGasSystems-${rowIndex}`"
          [name]="`entries-inertGasSystems-${rowIndex}`"
          [min]="0"
          [value]="item.inertGasSystems.value"
          [ngModel]="item.inertGasSystems.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
        <nsp-number-input
          [id]="`entries-bunkerHeating-${rowIndex}`"
          [name]="`entries-bunkerHeating-${rowIndex}`"
          [min]="0"
          [value]="item.bunkerHeating.value"
          [ngModel]="item.bunkerHeating.value"
          [disabled]="
            !consumptionsStore.fuelSpecs().entries[rowIndex].fuelType.value
          "
        />
      </div>
    }
  </div>
</form>
